var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyNearWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.124 69.7501C125.825 64.2233 132.83 60.7171 140.653 60.7171C154.806 60.7171 166.279 72.1901 166.279 86.3426V181.578H202.996V86.3426C202.996 51.9117 175.084 24 140.653 24C122.691 24 106.503 31.5966 95.1265 43.7523L121.124 69.7501Z",
    fill: "url(#paint0_linear_810_17088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.876 170.25C114.175 175.777 107.17 179.283 99.3467 179.283C85.1941 179.283 73.7212 167.81 73.7212 153.657V58.4223H37.0041V153.657C37.0041 188.088 64.9158 216 99.3467 216C117.309 216 133.497 208.403 144.874 196.248L118.876 170.25Z",
    fill: "url(#paint1_linear_810_17088)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.996 175.99L60.5089 33.5028C51.835 24.8289 37.0039 30.9721 37.0039 43.2389V62.6859L179.491 205.173C188.165 213.847 202.996 207.704 202.996 195.437V175.99Z",
    fill: "url(#paint2_linear_810_17088)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_810_17088",
    x1: 149.061,
    y1: 24,
    x2: 149.061,
    y2: 181.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACD7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149EEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_810_17088",
    x1: 90.9388,
    y1: 216,
    x2: 90.9388,
    y2: 58.4223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8233FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_810_17088",
    x1: 37.0039,
    y1: 38.5339,
    x2: 202.996,
    y2: 200.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D5DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48BCFD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNearWallet);
export default __webpack_public_path__ + "static/media/my-near-wallet.de6fd3af641182ef4b6cd713fd895cb0.svg";
export { ForwardRef as ReactComponent };